module.exports = __webpack_public_path__ + "static/media/test_manager_logo.81d11ff5.png";